export const MMKVStoreKeyMap = {
  qnaFeedStore: 'qnaFeedStore',
};
